import React, { useEffect, useState } from 'react';
import api from '../../api';

const SELECT = {
    width: '100%', padding: '10px 12px',
    border: '1px solid #e0e4ea', borderRadius: 4,
    fontSize: '1rem', color: '#1a1a2e',
    background: '#fff', outline: 'none',
    boxSizing: 'border-box', appearance: 'auto',
};

const PrefectureCitySelect = ({
    prefecture,
    city,
    onPrefectureChange,
    onCityChange,
    required = false,
    showLabel = true,
}) => {
    const [prefectures, setPrefectures] = useState([]);
    const [cities, setCities] = useState([]);
    const [citiesLoading, setCitiesLoading] = useState(false);

    useEffect(() => {
        api.get('service_area_prefectures')
            .then(r => setPrefectures(r.data))
            .catch(console.error);
    }, []);

    useEffect(() => {
        if (!prefecture) { setCities([]); onCityChange(''); return; }
        const found = prefectures.find(p => p.name === prefecture);
        if (!found) return;
        setCitiesLoading(true);
        api.get(`service_area_cities?prefecture_id=${found.id}`)
            .then(r => setCities(r.data))
            .catch(console.error)
            .finally(() => setCitiesLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [prefecture, prefectures]);

    return (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 8 }}>
            <div>
                {showLabel && <label style={{ display: 'block', fontSize: '0.82rem', fontWeight: 500, color: '#1a1a2e', marginBottom: 4 }}>都道府県{required && ' *'}</label>}
                <select
                    value={prefecture}
                    onChange={e => onPrefectureChange(e.target.value)}
                    required={required}
                    style={SELECT}
                >
                    <option value="">都道府県を選択</option>
                    {prefectures.map(p => (
                        <option key={p.id} value={p.name}>{p.name}</option>
                    ))}
                </select>
            </div>
            <div>
                {showLabel && <label style={{ display: 'block', fontSize: '0.82rem', fontWeight: 500, color: '#1a1a2e', marginBottom: 4 }}>市区町村{required && ' *'}</label>}
                <select
                    value={city}
                    onChange={e => onCityChange(e.target.value)}
                    disabled={!prefecture || citiesLoading}
                    required={required}
                    style={{ ...SELECT, color: !prefecture ? '#9ca3af' : '#1a1a2e' }}
                >
                    <option value="">
                        {citiesLoading ? '読み込み中...' : prefecture ? '市区町村を選択' : '先に都道府県を選択'}
                    </option>
                    {cities.map(c => (
                        <option key={c.id} value={c.name}>{c.name}</option>
                    ))}
                </select>
            </div>
        </div>
    );
};

export default PrefectureCitySelect;
